import { useScrollAnimation } from "../hooks/useScrollAnimation";
import { useTranslation } from "../hooks/useTranslation";

function Catalogue() {
  const { t } = useTranslation();
  const [titleRef, titleVisible] = useScrollAnimation();
  const [card1Ref, card1Visible] = useScrollAnimation();
  const [card2Ref, card2Visible] = useScrollAnimation();
  const [card3Ref, card3Visible] = useScrollAnimation();
  const [card4Ref, card4Visible] = useScrollAnimation();
  const [card5Ref, card5Visible] = useScrollAnimation();
  const [card6Ref, card6Visible] = useScrollAnimation();
  const [card7Ref, card7Visible] = useScrollAnimation();
  const [card8Ref, card8Visible] = useScrollAnimation();
  const [card9Ref, card9Visible] = useScrollAnimation();
  const [card10Ref, card10Visible] = useScrollAnimation();
  const [card11Ref, card11Visible] = useScrollAnimation();

  const handleLearnMore = (catalogPath) => {
    if (catalogPath && catalogPath !== "#") {
      window.open(catalogPath, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <div className="catalogue-wrapper">
      <div className="catalogue">
        <div className="catalogue-content container">
          <div
            ref={titleRef}
            className={`catalogue-title-wrapper ${
              titleVisible ? "animate-in" : ""
            }`}
          >
            <div className="catalogue-title flex">
              <div className="circle"></div>
              <h4 className="clr-green fs-700">{t("catalogue.aboutUs")}</h4>
            </div>
            <h2 className="fs-1000 clr-dark">
              {t("catalogue.productCatalogue")}
            </h2>
          </div>
          <div className="catalogue-items flex">
            <div
              ref={card1Ref}
              className={`catalogue-card ${card1Visible ? "animate-in" : ""}`}
            >
              <img src="/assets/icons/rectangular.svg" alt="Rectangular Icon" />
              <h3 className="fs-700 clr-dark">{t("catalogue.rectangular")}</h3>
              <p className="clr-gray-light fs-400">
                {t("catalogue.rectangularDesc")}
              </p>
              <button
                className="fs-500 clr-white transition pointer"
                onClick={() => handleLearnMore("/CATALOG_Drejtkendore.png")}
              >
                Learn More
              </button>
              <div className="box-left"></div>
              <div className="box-right"></div>
              <div className="box-bottom"></div>
            </div>
            <div
              ref={card2Ref}
              className={`catalogue-card ${card2Visible ? "animate-in" : ""}`}
            >
              <img src="/assets/icons/circular.svg" alt="Circular Icon" />
              <h3 className="fs-700 clr-dark">{t("catalogue.circular")}</h3>
              <p className="clr-gray-light fs-400">
                {t("catalogue.circularDesc")}
              </p>
              <button
                className="fs-500 clr-white transition pointer"
                onClick={() => handleLearnMore("/CATALOG_Rrethore.png")}
              >
                Learn More
              </button>
              <div className="box-left"></div>
              <div className="box-right"></div>
              <div className="box-bottom"></div>
            </div>
            <div
              ref={card3Ref}
              className={`catalogue-card ${card3Visible ? "animate-in" : ""}`}
            >
              <img src="/assets/icons/square.svg" alt="Square Icon" />
              <h3 className="fs-700 clr-dark">{t("catalogue.square")}</h3>
              <p className="clr-gray-light fs-400">
                {t("catalogue.squareDesc")}
              </p>
              <button
                className="fs-500 clr-white transition pointer"
                onClick={() => handleLearnMore("/CATALOG_Katrori.png")}
              >
                Learn More
              </button>
              <div className="box-left"></div>
              <div className="box-right"></div>
              <div className="box-bottom"></div>
            </div>
            <div
              ref={card4Ref}
              className={`catalogue-card ${card4Visible ? "animate-in" : ""}`}
            >
              <img src="/assets/icons/profileu.svg" alt="Profile U Icon" />
              <h3 className="fs-700 clr-dark">{t("catalogue.profileU")}</h3>
              <p className="clr-gray-light fs-400">
                {t("catalogue.profileUDesc")}
              </p>
              <button
                className="fs-500 clr-white transition pointer"
                onClick={() => handleLearnMore("#")}
              >
                Learn More
              </button>
              <div className="box-left"></div>
              <div className="box-right"></div>
              <div className="box-bottom"></div>
            </div>
            <div
              ref={card5Ref}
              className={`catalogue-card ${card5Visible ? "animate-in" : ""}`}
            >
              <img src="/assets/icons/profilez.svg" alt="Profile H Icon" />
              <h3 className="fs-700 clr-dark">{t("catalogue.profileH")}</h3>
              <p className="clr-gray-light fs-400">
                {t("catalogue.profileHDesc")}
              </p>
              <button
                className="fs-500 clr-white transition pointer"
                onClick={() => handleLearnMore("#")}
              >
                Learn More
              </button>
              <div className="box-left"></div>
              <div className="box-right"></div>
              <div className="box-bottom"></div>
            </div>
            <div
              ref={card7Ref}
              className={`catalogue-card ${card7Visible ? "animate-in" : ""}`}
            >
              <img src="/assets/icons/profilep.svg" alt="Profile P Icon" />
              <h3 className="fs-700 clr-dark">{t("catalogue.profileP")}</h3>
              <p className="clr-gray-light fs-400">
                {t("catalogue.profilePDesc")}
              </p>
              <button
                className="fs-500 clr-white transition pointer"
                onClick={() => handleLearnMore("#")}
              >
                Learn More
              </button>
              <div className="box-left"></div>
              <div className="box-right"></div>
              <div className="box-bottom"></div>
            </div>
            <div
              ref={card8Ref}
              className={`catalogue-card ${card8Visible ? "animate-in" : ""}`}
            >
              <img src="/assets/icons/profilei.svg" alt="Profile I Icon" />
              <h3 className="fs-700 clr-dark">{t("catalogue.profileI")}</h3>
              <p className="clr-gray-light fs-400">
                {t("catalogue.profileIDesc")}
              </p>
              <button
                className="fs-500 clr-white transition pointer"
                onClick={() => handleLearnMore("#")}
              >
                Learn More
              </button>
              <div className="box-left"></div>
              <div className="box-right"></div>
              <div className="box-bottom"></div>
            </div>
            <div
              ref={card9Ref}
              className={`catalogue-card ${card9Visible ? "animate-in" : ""}`}
            >
              <img src="/assets/icons/roundbars.svg" alt="Round Bars Icon" />
              <h3 className="fs-700 clr-dark">{t("catalogue.roundBars")}</h3>
              <p className="clr-gray-light fs-400">
                {t("catalogue.roundBarsDesc")}
              </p>
              <button
                className="fs-500 clr-white transition pointer"
                onClick={() => handleLearnMore("#")}
              >
                Learn More
              </button>
              <div className="box-left"></div>
              <div className="box-right"></div>
              <div className="box-bottom"></div>
            </div>
            <div
              ref={card10Ref}
              className={`catalogue-card ${card10Visible ? "animate-in" : ""}`}
            >
              <img src="/assets/icons/profilel.svg" alt="Profile L Icon" />
              <h3 className="fs-700 clr-dark">{t("catalogue.profileL")}</h3>
              <p className="clr-gray-light fs-400">
                {t("catalogue.profileLDesc")}
              </p>
              <button
                className="fs-500 clr-white transition pointer"
                onClick={() => handleLearnMore("#")}
              >
                Learn More
              </button>
              <div className="box-left"></div>
              <div className="box-right"></div>
              <div className="box-bottom"></div>
            </div>
            <div
              ref={card11Ref}
              className={`catalogue-card ${card11Visible ? "animate-in" : ""}`}
            >
              <img src="/assets/icons/flets.svg" alt="Flets Icon" />
              <h3 className="fs-700 clr-dark">{t("catalogue.flets")}</h3>
              <p className="clr-gray-light fs-400">
                {t("catalogue.fletsDesc")}
              </p>
              <button
                className="fs-500 clr-white transition pointer"
                onClick={() => handleLearnMore("#")}
              >
                Learn More
              </button>
              <div className="box-left"></div>
              <div className="box-right"></div>
              <div className="box-bottom"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Catalogue;
